"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHOTO_UPLOAD_DEFAULTS = exports.IMAGE_CONTAINER = exports.IMAGE = exports.DELETE = void 0;
var PHOTO_UPLOAD_DEFAULTS = {
  LABEL: 'Attach photo',
  ICON: 'AttachFileIcon',
  ID: 'airasia-photoupload',
  ICON_COLOR: 'greyDark',
  DESC_COLOR: 'greyDarker',
  HEADLINE_COLOR: 'black'
};
exports.PHOTO_UPLOAD_DEFAULTS = PHOTO_UPLOAD_DEFAULTS;
var IMAGE_CONTAINER = {
  HEIGHT: '85px',
  WIDTH: '85px'
};
exports.IMAGE_CONTAINER = IMAGE_CONTAINER;
var IMAGE = {
  HEIGHT: '75px',
  WIDTH: '75px'
};
exports.IMAGE = IMAGE;
var DELETE = {
  BORDER_COLOR: '#aeaeae',
  BACKGROUND: '#808080',
  FONT: 'Verdana, sans-serif'
};
exports.DELETE = DELETE;